

exports.__esModule = true;

var _angular = require('angular');

var _uiRouter = require('uiRouter');

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _index = require('xo-models/src/checkout/index');

var _index2 = require('xo-models/src/auth/index');

var _util = require('xo-return-to-merchant/dist/util');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _app = require('xo-models/src/app');

var _template = require('./template.html');

var _template2 = _interopRequireDefault(_template);

require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TITLE_KEY_MAPPING = {
    PAYMENT_PROCESS_ERROR: 'paymentProcessError',
    BLOCK_NON_DOMESTIC_SHIPPING: 'blockNonDomesticShippingTitle',
    BLOCK_PPC_INELIGIBLE_USER: 'blockPPCIneligibleTitle',
    PAYER_COUNTRY_NOT_ALLOWED: 'payerCountryNotAllowedTitle',
    XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'payerCountryNotAllowedTitleSignupDCF',
    HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'payerCountryNotAllowedTitleMemberDCF',
    PAYER_COUNTRY_NOT_ENABLED: 'payerCountryNotAllowedTitle',
    PAYER_LOGIN_COUNTRY_NOT_ALLOWED: 'payerCountryNotAllowedTitle',
    TRANSACTION_REFUSED: 'transactionRefusedTitle',
    COMPLIANCE_VIOLATION: 'transactionRefusedTitle',
    DOMESTIC_TRANSACTION_REQUIRED: 'domesticTransactionRequiredTitle',
    INTERNAL_SERVICE_ERROR: 'transactionRefusedTitle',
    NEGATIVE_BALANCE_TRANSACTION_REFUSED: 'negativeBalanceRefusedTitle',
    STUDENT_ACCOUNT: 'studentAccountTitle',
    RETRY: 'sorry'
};

var CONTENT_KEY_MAPPING = {
    INVALID_RESOURCE_ID: 'expiredOrTokenNotFoundError',
    EXPIRED_SESSION: 'expiredOrTokenNotFoundError',
    PAYMENT_ALREADY_DONE: 'paymentAlreadyCompletedError',
    PAYEE_BLOCKED_TRANSACTION: 'paymentDeniedError',
    PAYER_CANNOT_PAY: 'paymentDeniedError',
    RESTRICTED_USER: 'buyerRestrictedError',
    PAYMENT_DENIED: 'paymentDeniedError',
    UNSUPPORTED_PAYEE_CURRENCY: 'unsupportedPayeeCurrency',
    GUEST_UPGRADE_SESSION_ERROR: 'guestUpgradeSessionError',
    GUEST_UPGRADE_ERROR: 'guestUpgradeError',
    BLOCK_NON_DOMESTIC_SHIPPING: 'blockNonDomesticShippingMessage',
    BLOCK_PPC_INELIGIBLE_USER: 'blockPPCIneligibleMessage',
    PAYER_COUNTRY_NOT_ALLOWED: 'unauthorizedCountryAccountRegistered',
    XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'unauthorizedCountryAccountSignupDCF',
    HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'unauthorizedCountryAccountMemberDCF',
    PAYER_COUNTRY_NOT_ENABLED: 'rpUnauthorizedCountryMessage',
    PAYER_LOGIN_COUNTRY_NOT_ALLOWED: 'unauthorizedCountryLogin',
    PAYMENT_PROCESS_ERROR: 'chooseOtherWayToPay',
    GAMING_FUNDING_SOURCE_VALIDATION_FAILED: 'unauthorizedCountryAccountRegistered',
    SENDING_LIMIT_EXCEEDED: 'sendingLimitExceeded',
    TRANSACTION_LIMIT_EXCEEDED: 'transactionLimitExceeded',
    TRANSACTION_REFUSED: 'transactionRefusedMessage',
    COMPLIANCE_VIOLATION: 'complianceViolationMessage',
    DOMESTIC_TRANSACTION_REQUIRED: 'domesticTransactionRequiredMessage',
    INTERNAL_SERVICE_ERROR: 'transactionRefusedMessage',
    DEFAULT: 'genericError',
    NEGATIVE_BALANCE_TRANSACTION_REFUSED: 'negativeBalanceRefusedMessage',
    ACCOUNT_CANNOT_BE_FETCHED: 'genericError',
    STUDENT_ACCOUNT: 'studentAccountMessage',
    RETRY: 'thingsNotWorking',
    DEFAULT_TOKENIZED_WALLET_ERROR: 'tokenizedWalletGenericError',
    // TODO: rename to a common one, e.g TOKENIZED_WALLET_ELIGIBILITY_ERROR later
    ANDROID_PAY_ELIGIBILITY_ERROR: 'tokenizedWalletGenericError',
    DUPLICATE_INVOICE_ID: 'duplicateInvoiceId',
    UNSUPPORTED_COUNTRY: 'unsupportedCountry',
    // TODO: rename to a common one, e.g TOKENIZED_WALLET_ALREADY_PROVISIONED later
    ANDROID_PAY_ALREADY_PROVISIONED: 'tokenizedWalletAlreadyProvisioned'
};

// pass merchantName attribute, if undefined, then suffix 'Default' to key
var renderContentWithMerchantName = function renderContentWithMerchantName(key) {
    var merchantName = this.props.merchant;

    if (merchantName) {
        return (0, _squid.$renderContent)(key, { merchantName: merchantName });
    }

    return (0, _squid.$renderContent)(key + 'Default');
};

var renderContentWithWalletTokenizationName = function renderContentWithWalletTokenizationName(key) {
    var brandName = this.models.tokenizedWalletInfoModel.brandName();

    return (0, _squid.$renderContent)(key, { type: brandName });
};

// handle non-standard merchant error title strings
var TITLE_KEY_HANDLER = {
    DOMESTIC_TRANSACTION_REQUIRED: renderContentWithMerchantName,
    XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName,
    HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName,
    DEFAULT_TOKENIZED_WALLET_ERROR: renderContentWithWalletTokenizationName,
    ANDROID_PAY_ALREADY_PROVISIONED: renderContentWithWalletTokenizationName
};

// handle non-standard merchant error content strings
var CONTENT_KEY_HANDLER = {
    DOMESTIC_TRANSACTION_REQUIRED: renderContentWithMerchantName,
    XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName,
    HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName
};

var SHOW_LOGOUT_LINK_CODES = ['HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF', 'ANDROID_PAY_COUNTRY_NOT_SUPPORTED', 'ANDROID_PAY_ALREADY_PROVISIONED'];

var HIDE_CANCEL_LINK_CODES = ['PAYER_COUNTRY_NOT_ALLOWED', 'GAMING_FUNDING_SOURCE_VALIDATION_FAILED', 'PAYER_LOGIN_COUNTRY_NOT_ALLOWED'];

var RETRY_LINK = ['RETRY'];

var TRANSACTION_REFUSED_BA_TITLE_MSG = {
    BA_NO_PURCHASE: 'transactionRefusedBAnoPurchaseTitle',
    BA_WITH_PURCHASE: 'transactionRefusedBAPurchaseTitle'
};

/* eslint-disable fasec/no-unsafe-regex */
var base64regex = new RegExp('^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$');

exports['default'] = _squid.$Component.extend('$xoGenericErrorComponent', {

    tag: 'xo-generic-error',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        },
        logout: {
            type: 'var',
            required: false
        },
        isUnbranded: {
            type: 'var',
            required: false
        },
        cancelUrl: {
            type: 'str',
            required: false
        },
        merchant: {
            type: 'str',
            required: false,
            'default': function _default() {
                if (this.models && this.models.checkoutAppData && this.models.checkoutAppData.merchant) {
                    var merchant = this.models.checkoutAppData.merchant;
                    return merchant.brand_name || merchant.merchant_name;
                }
            }
        }
    },

    resolve: {
        models: function models() {
            if (this.props.token) {
                return {
                    checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](angular.noop),
                    cart: _index.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](angular.noop),
                    checkoutPayee: _index.$CheckoutPayeeModel.instance(this.props.token).retrieve()['catch'](angular.noop),
                    auth: _index2.$AuthModel.instance().retrieve()['catch'](angular.noop),
                    tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance(this.props.token).retrieve()['catch'](angular.noop)
                };
            }
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            var cancelPreventStateChange = _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                event.preventDefault();
            });

            this.$on('$destroy', cancelPreventStateChange);

            var self = this;

            // to not break other application's error integration, we'll still support base64 decoded code parameters
            if (_uiRouter.$stateParams.code && base64regex.test(_uiRouter.$stateParams.code)) {
                self.errorCode = _squid.$util.base64Decode(_uiRouter.$stateParams.code);
            } else {
                self.errorCode = _uiRouter.$stateParams.code;
            }

            self.hideCancelLink = HIDE_CANCEL_LINK_CODES.indexOf(self.errorCode) > -1;
            self.retryLink = RETRY_LINK.indexOf(self.errorCode) > -1;

            _angular.$rootScope.allowUnload = true;
            self.cancelLink = self.props.cancelUrl;

            self.cancelRedirect = function ($event) {
                $event.preventDefault();
                var redirectUrl = self.cancelLink;

                if (_angular.$rootScope.partnerIntegration) {
                    _logger.$logger.info('genericerror_partner_integration');
                    redirectUrl = _squid.$util.buildURL(self.cancelLink, { error: 'true' });
                }

                _util.$ReturnToMerchant.goTo(redirectUrl);
            };

            self.retryCheckout = function ($event) {
                $event.preventDefault();

                _squid.$util.reload();
            };

            self.isMessengerBAIntegration = _squid.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');

            self.loggingOut = function ($event) {
                $event.preventDefault();
                cancelPreventStateChange();
                self.props.logout();
            };

            (0, _jquery2['default'])('.paypalHeaderWrapper').hide();
            // Cancel link should be shown for "Credit Ineligible" page for DE
            if (self.errorCode !== 'BLOCK_PPC_INELIGIBLE_USER') {
                (0, _jquery2['default'])('#defaultCancelLink').hide();
            }
            (0, _jquery2['default'])('.footerWrapper').addClass('genericError');

            self.$on('$destroy', function (event) {
                (0, _jquery2['default'])('.paypalHeaderWrapper').show();
                if (self.errorCode !== 'BLOCK_PPC_INELIGIBLE_USER') {
                    (0, _jquery2['default'])('#defaultCancelLink').show();
                }
                (0, _jquery2['default'])('.footerWrapper').removeClass('genericError');
            });

            // Returns the title string, based on custom key handler
            self.getTitle = function () {
                var key = self.titleKey;

                if (TITLE_KEY_HANDLER.hasOwnProperty(self.errorCode)) {
                    return TITLE_KEY_HANDLER[self.errorCode].call(_this, key);
                }

                return (0, _squid.$renderContent)(key);
            };

            // Returns the content string, based on custom key handler
            self.getContent = function () {

                var key = self.contentKey;

                if (CONTENT_KEY_HANDLER.hasOwnProperty(self.errorCode)) {
                    return CONTENT_KEY_HANDLER[self.errorCode].call(_this, key);
                }

                return (0, _squid.$renderContent)(key);
            };

            // Returns the cancel button label, based on presence of brand/merchant name
            self.getCancelLabel = function () {
                if (self.walletTokenization) {
                    var brandName = _this.models.tokenizedWalletInfoModel.brandName();
                    if (self.errorCode === 'ANDROID_PAY_ALREADY_PROVISIONED') {
                        return (0, _squid.$renderContent)('common.backToTokenizedWalletB', { type: brandName });
                    } else {
                        return (0, _squid.$renderContent)('common.backToTokenizedWallet', { type: brandName });
                    }
                } else {
                    var merchantName = _this.props.merchant;
                    if (merchantName) {
                        return (0, _squid.$renderContent)('common.returnToMerchant', { merchantName: merchantName });
                    }

                    return (0, _squid.$renderContent)('common.returnToDefaultMerchant');
                }
            };
            this.personalizedBanner = {
                show: false
            };

            _logger.$logger.info('checkout_fpti', {
                landing_page: 'error_page',
                int_error_code: '1',
                int_error_description: _uiRouter.$stateParams.code
            });
        },
        populate: function populate() {
            if (this.models.checkoutAppData) {
                this.cancelLink = this.models.checkoutAppData.urls.cancel_url;
            }

            if (this.models.checkoutPayee) {
                var merchant = this.models.checkoutPayee.merchant;

                if (merchant.id && !this.hideCancelLink) {
                    var hcl = _squid.$config.hideCancelLinkForMerchant;

                    var shouldHide = hcl && hcl.indexOf(merchant.id) !== -1;
                    if (shouldHide) {
                        this.hideCancelLink = true;
                    }
                }
            }

            if (this.models.cart) {
                this.walletTokenization = this.models.cart.isWalletTokenization();
            }

            this.personalizedBanner.show = this.models.auth && this.models.auth.rememberedOT() && (0, _squid.$feature)('oneTouchPersonalization');

            if (this.models.auth) {
                this.showLogoutLink = this.models.auth.is_auth_api_call && _squid.$util.param('source') !== 'consumerApp' && this.props.logout && SHOW_LOGOUT_LINK_CODES.indexOf(this.errorCode) > -1;

                this.formattedNameInformal = (0, _squid.formatNameInformal)({
                    first_name: this.models.auth.first_name,
                    last_name: this.models.auth.last_name
                }) || this.models.auth.email;
            }

            // Map error code for Android Pay
            if (this.walletTokenization) {
                // For Android Pay, map all errors to generic Android Pay error except for
                // ANDROID_PAY_ALREADY_PROVISIONED
                if (this.errorCode !== 'ANDROID_PAY_ALREADY_PROVISIONED') {
                    this.errorCode = 'DEFAULT_TOKENIZED_WALLET_ERROR';
                }
            }

            var titleKey = this.errorCode && TITLE_KEY_MAPPING[this.errorCode];
            if (titleKey) {
                if (titleKey === 'transactionRefusedTitle' && this.models.cart && this.models.cart.isBillingNoPurchase()) {
                    this.titleKey = 'genericError.' + TRANSACTION_REFUSED_BA_TITLE_MSG['BA_NO_PURCHASE'];
                } else if (titleKey === 'transactionRefusedTitle' && this.models.cart && this.models.cart.isBillingPurchase()) {
                    this.titleKey = 'genericError.' + TRANSACTION_REFUSED_BA_TITLE_MSG['BA_WITH_PURCHASE'];
                } else {
                    this.titleKey = 'genericError.' + titleKey;
                }
            }

            var contentKey = this.errorCode && CONTENT_KEY_MAPPING[this.errorCode] || CONTENT_KEY_MAPPING.DEFAULT;
            this.contentKey = 'genericError.' + contentKey;
        }
    }

});


_angular.$rootScope;

_uiRouter.$stateParams;

_squid.$Component;

_squid.$util;

_squid.$renderContent;

_squid.$config;

_squid.formatNameInformal;

_squid.$integration;

_squid.$feature;

_logger.$logger;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_index2.$AuthModel;

_util.$ReturnToMerchant;

_app.$TokenizedWalletInfoModel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-ui-components/src/generic-error/directive.js
// module id = ./components/xo-ui-components/src/generic-error/directive.js
// module chunks = 1